import React from 'react';

interface TextFlowLogoProps {
  className?: string;
  size?: number;
}

export const TextFlowLogo: React.FC<TextFlowLogoProps> = ({ 
  className = "", 
  size = 32 
}) => {
  return (
    <div 
      className={`flex-shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Ultra minimal message icon */}
        <path 
          d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5.5l-4 4v-4H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <circle cx="8" cy="11" r="1" fill="currentColor" />
        <circle cx="12" cy="11" r="1" fill="currentColor" />
        <circle cx="16" cy="11" r="1" fill="currentColor" />
      </svg>
    </div>
  );
};